import { ComponentType, ReactNode, MouseEvent } from 'react';
import { Tooltip } from '@material-ui/core';
import { DsmButton } from '@dsm-dcs/design-system-react';

interface GuardedButtonProps {
  onClick: (event?: MouseEvent) => void;
  children: ReactNode;
  // eslint-disable-next-line react/require-default-props
  as?: ComponentType<any>;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  // When true, the button is disabled and the tooltip shows `lockedReason` instead of `tooltip`.
  // eslint-disable-next-line react/require-default-props
  locked?: boolean;
  // eslint-disable-next-line react/require-default-props
  lockedReason?: string;
  // Tooltip shown while not locked. Falls back to `lockedReason` when locked and no reason is given.
  // eslint-disable-next-line react/require-default-props
  tooltip?: string;
  [key: string]: any;
}

// Wraps a button with a Tooltip and disables it (no-op onClick) while `locked`.
const GuardedButton = ({
  onClick,
  children,
  as: Component = DsmButton,
  disabled = false,
  locked = false,
  lockedReason,
  tooltip = '',
  ...rest
}: GuardedButtonProps) => (
  <Tooltip title={locked ? lockedReason ?? tooltip : tooltip}>
    <Component
      {...rest}
      disabled={disabled || locked}
      onClick={(event?: MouseEvent) => (!locked ? onClick(event) : undefined)}
    >
      {children}
    </Component>
  </Tooltip>
);

export default GuardedButton;
